import example from 'assets/example.jpg';
import { SiteMaterialQualityReport } from 'features';
import { useParams } from 'react-router-dom';
import { Button, Stack } from 'ui';

export const InternalQualityReport = () => {
  const { siteMaterialId } = useParams<{ siteMaterialId: string }>();

  if (siteMaterialId === undefined) {
    throw new Error('Material not found.');
  }

  const handleClick = () => {
    window.open(`/report/${siteMaterialId}`, '_blank');
  };

  return (
    <>
      <Stack textAlign="right" py={2}>
        <Button onClick={handleClick}>Link to public quality report</Button>
      </Stack>
      <SiteMaterialQualityReport
        siteMaterialId={String(siteMaterialId)}
        placeholderSrc={example}
        source="QUALITY_REPORT"
      />
    </>
  );
};
